import React, { useState, useEffect, useRef } from "react";
import "./StatsCounter.css";

function StatsCounter({ stats }) {
  const [isVisible, setIsVisible] = useState(false);
  const counterRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    if (counterRef.current) {
      observer.observe(counterRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className="stats-container" ref={counterRef}>
      {stats.map((stat, index) => (
        <div className="stat-item" key={index}>
          <div className="stat-icon">{stat.icon}</div>
          <div className="stat-number">
            <AnimatedNumber
              value={stat.value}
              isVisible={isVisible}
              suffix={stat.suffix || ""}
            />
          </div>
          <div className="stat-label">{stat.label}</div>
        </div>
      ))}
    </div>
  );
}

function AnimatedNumber({ value, isVisible, suffix }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!isVisible) return;

    let start = 0;
    const duration = 2000;
    const increment = value / (duration / 16);

    const timer = setInterval(() => {
      start += increment;
      if (start >= value) {
        setCount(value);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);

    return () => clearInterval(timer);
  }, [isVisible, value]);

  return (
    <span>
      {count}
      {suffix}
    </span>
  );
}

export default StatsCounter;
